export const TRANSPORTATION_TYPE = {
  walk: 0,
  train: 1,
  bus: 2,
  my_car: 3,
  bicycle: 4,
  other: 99,
} as const;

export const TRANSPORTATION_TYPE_NAME = {
  walk: "徒歩",
  train: "鉄道",
  bus: "バス",
  my_car: "マイカー",
  bicycle: "自転車",
  other: "その他",
} as const;

export const getTransportationType = (
  givenTransportationType: number
): string | undefined => {
  // eslint-disable-next-line no-restricted-syntax
  for (const [key, value] of Object.entries(TRANSPORTATION_TYPE)) {
    if (value === givenTransportationType) return key;
  }
  return undefined;
};

export const getTransportationTypeName = (
  transportationType: string
): string | undefined => {
  // eslint-disable-next-line no-restricted-syntax
  for (const [key, value] of Object.entries(TRANSPORTATION_TYPE_NAME)) {
    if (key === transportationType) return value;
  }
  return undefined;
};
